import React from 'react';
import { Provider } from 'react-redux'; 
import store from './src/store';
import PageBase from './src/components/common/page-base';
import { changeLanguage } from './src/actions/language';
import { getLanguageFromPath } from './src/utils/language-route';

export const wrapRootElement = ({element}) => (
	<Provider store={store}>
			{element}
	</Provider>
);

export const wrapPageElement = ({ element, props }) => {
	const pathname = props.location ? props.location.pathname : props.path;
	store.dispatch(changeLanguage(getLanguageFromPath(pathname)));
	return (
		<PageBase props={ props }>
			{ element }
		</PageBase>
	)
}

export const shouldUpdateScroll = () => {
	return false;
}
